package com.example.monetix.db

import app.cash.sqldelight.Query
import app.cash.sqldelight.SuspendingTransacterImpl
import app.cash.sqldelight.db.SqlDriver
import kotlin.Any
import kotlin.Boolean
import kotlin.Long
import kotlin.String

public class CategoryQueries(
  driver: SqlDriver,
) : SuspendingTransacterImpl(driver) {
  public fun <T : Any> getAllCategories(mapper: (
    id: String,
    name: String,
    isDeleted: Boolean,
    createdAtEpochMs: Long,
    updatedAtEpochMs: Long,
  ) -> T): Query<T> = Query(-1_401_046_150, arrayOf("CategoryEntity"), driver, "Category.sq",
      "getAllCategories",
      "SELECT CategoryEntity.id, CategoryEntity.name, CategoryEntity.isDeleted, CategoryEntity.createdAtEpochMs, CategoryEntity.updatedAtEpochMs FROM CategoryEntity WHERE isDeleted = 0") {
      cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getBoolean(2)!!,
      cursor.getLong(3)!!,
      cursor.getLong(4)!!
    )
  }

  public fun getAllCategories(): Query<CategoryEntity> = getAllCategories { id, name, isDeleted,
      createdAtEpochMs, updatedAtEpochMs ->
    CategoryEntity(
      id,
      name,
      isDeleted,
      createdAtEpochMs,
      updatedAtEpochMs
    )
  }

  public suspend fun upsert(
    id: String,
    name: String,
    isDeleted: Boolean,
    createdAtEpochMs: Long,
    updatedAtEpochMs: Long,
  ) {
    driver.execute(93_871_490, """
        |INSERT OR REPLACE INTO CategoryEntity(id, name, isDeleted, createdAtEpochMs, updatedAtEpochMs)
        |VALUES (?, ?, ?, ?, ?)
        """.trimMargin(), 5) {
          bindString(0, id)
          bindString(1, name)
          bindBoolean(2, isDeleted)
          bindLong(3, createdAtEpochMs)
          bindLong(4, updatedAtEpochMs)
        }.await()
    notifyQueries(93_871_490) { emit ->
      emit("CategoryEntity")
    }
  }

  public suspend fun softDelete(updatedAtEpochMs: Long, id: String) {
    driver.execute(-1_503_592_120,
        """UPDATE CategoryEntity SET isDeleted = 1, updatedAtEpochMs = ? WHERE id = ?""", 2) {
          bindLong(0, updatedAtEpochMs)
          bindString(1, id)
        }.await()
    notifyQueries(-1_503_592_120) { emit ->
      emit("CategoryEntity")
    }
  }
}
